<ng-container *ngIf="order$ | async as order">
  <cx-order-overview></cx-order-overview>
</ng-container>
